import Image from "next/image";
// import { generalSupervisors , supervisors } from "@/pages/team";
import Link from "next/link";

export interface Member {
  name: string;
  thumbnail: string;
  role: string;
  group: string;
}

interface TeamProps {
  coresMembers?: Member[];
}

const Team = ({ coresMembers = [] }: TeamProps) => {
  if (!coresMembers.length) {
    return null;
  }

  const generalSupervisors: Member[] = coresMembers.filter((m) => m.group === "general_supervisors");
  const supervisors: Member[] = coresMembers.filter((m) => m.group === "supervisors");
  return (
    <section>
      <div className="container mt-10">
        <div className="mb-12 flex items-center justify-between gap-4">
          <h2 className="mb-4 text-start text-3xl font-extrabold sm:text-4xl">Our Team</h2>
          <Link href="/team">
            <a className="z-10 inline-block cursor-pointer rounded-md border border-transparent bg-slate-900 py-3 px-10 text-center font-medium text-white hover:bg-slate-700">Meet our team</a>
          </Link>
        </div>

        <div className="mx-auto grid max-w-sm grid-cols-2 gap-8 lg:max-w-lg lg:grid-flow-col-dense lg:grid-cols-none">
          {generalSupervisors.map((member, i) => (
            <div key={i} className="group">
              <div className="flex flex-col gap-4 overflow-hidden rounded-full">
                <Image
                  src={member.thumbnail}
                  alt={member.name}
                  width={1}
                  height={1}
                  layout="responsive"
                  priority
                  className="object-cover object-center"
                />
              </div>
            </div>
          ))}
        </div>
        <br />
        <div className="mx-auto grid max-w-sm grid-cols-3 gap-8 lg:max-w-sm lg:grid-flow-col-dense lg:grid-cols-none">
          {supervisors.map((member, i) => (
            <div key={i} className="group">
              <div className="flex flex-col gap-4 overflow-hidden rounded-full">
                <Image
                  src={member.thumbnail}
                  alt={member.name}
                  width={1}
                  height={1}
                  layout="responsive"
                  priority
                  className="object-cover object-center"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
